﻿if (!window.__PRODUCT_CARD_COLOR_OPTIONS_INIT__) {
  window.__PRODUCT_CARD_COLOR_OPTIONS_INIT__ = true;

  function toInteger(value) {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) {
      return 0;
    }
    return Math.round(parsed);
  }

  function formatMoneyWithoutTrailingZeros(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const moneyFormat = (window.theme && window.theme.moneyFormat) || window.moneyFormat || (window.Shopify && window.Shopify.money_format) || '$';
      const formatted = window.Shopify.formatMoney(cents, moneyFormat);
      if (typeof formatted !== 'string') {
        return (toInteger(cents) / 100).toFixed(2).replace(/\.00$/, '');
      }
      return formatted.replace(/([\.,]00)(?!\d)/, '');
    }
    return (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  const COMPARE_PRICE_COLOR = '#999';

  function renderComparePrice(cents) {
    return '<span class="money compare-price" style="text-decoration: line-through; padding-left: 5px; color: ' + COMPARE_PRICE_COLOR + ';">' +
      formatMoneyWithoutTrailingZeros(cents) +
      '</span>';
  }

  function renderCardPrice(priceCents, compareAtCents, saleColor) {
    const safePrice = toInteger(priceCents);
    const safeCompareAt = toInteger(compareAtCents);

    if (safeCompareAt > safePrice) {
      return '' +
        '<span class="money price sale-price" style="--sale-price-color: ' + (saleColor || '') + ';">' + formatMoneyWithoutTrailingZeros(safePrice) + '</span>' +
        renderComparePrice(safeCompareAt);
    }

    return '<span class="money price">' + formatMoneyWithoutTrailingZeros(safePrice) + '</span>';
  }

  function renderProductCardPrice(el) {
    if (!el) return;

    const priceMin = parseInt(el.getAttribute('data-price-min'), 10) || 0;
    const priceMax = parseInt(el.getAttribute('data-price-max'), 10) || 0;
    const compareAt = parseInt(el.getAttribute('data-compare-at'), 10) || 0;
    const showRange = el.getAttribute('data-show-range') === 'true';
    const hideRec = el.getAttribute('data-hide-rec') === 'true';
    const allOnSale = el.getAttribute('data-all-on-sale') === 'true';
    const saleColor = el.getAttribute('data-sale-color') || '';

    // Already rendered (e.g. updated by swatch click — swatch click sets plain child nodes)
    if (el.children.length > 0) return;

    let html = '';

    if (hideRec && !showRange) {
      html = '<span class="money price">' + formatMoneyWithoutTrailingZeros(priceMin) + '</span>';
    } else if (priceMin < priceMax && showRange) {
      if (compareAt > priceMax) {
        html =
          '<span class="sale-price" style="--sale-price-color: ' + saleColor + ';">' +
            '<span class="money">' + formatMoneyWithoutTrailingZeros(priceMin) + '</span>' +
            '<span class="separator"> - </span>' +
            '<span class="money">' + formatMoneyWithoutTrailingZeros(priceMax) + '</span>' +
          '</span>' +
          renderComparePrice(compareAt);
      } else {
        html =
          '<span class="money price-min">' + formatMoneyWithoutTrailingZeros(priceMin) + '</span>' +
          '<span class="separator"> - </span>' +
          '<span class="money price-max">' + formatMoneyWithoutTrailingZeros(priceMax) + '</span>';
      }
    } else if (compareAt > priceMin) {
      html =
        '<span class="money price-min sale-price" style="--sale-price-color: ' + saleColor + ';">' +
          formatMoneyWithoutTrailingZeros(priceMin) +
        '</span>' +
        renderComparePrice(compareAt);
    } else {
      html = '<span class="money price">' + formatMoneyWithoutTrailingZeros(priceMin) + '</span>';
    }

    el.innerHTML = html;
  }

  function renderProductCardSaleBadge(el) {
    if (!el) return;

    const badgeDetail = el.getAttribute('data-badge-detail') === 'true';
    const v0Compare = parseInt(el.getAttribute('data-v0-compare'), 10) || 0;
    const v0Price = parseInt(el.getAttribute('data-v0-price'), 10) || 0;
    const compareMin = parseInt(el.getAttribute('data-compare-min'), 10) || 0;
    const priceMin = parseInt(el.getAttribute('data-price-min'), 10) || 0;

    const comparePrice = badgeDetail ? v0Compare : compareMin;
    const salePrice = badgeDetail ? v0Price : priceMin;
    const hasSale = comparePrice > salePrice && comparePrice > 0;

    if (!hasSale) {
      el.innerHTML = '';
      return;
    }

    const discountPercent = Math.floor((comparePrice - salePrice) * 100 / comparePrice);
    el.textContent = '-' + discountPercent + '%';
  }

  function initProductCardPricesAndBadges(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-price-container][data-price-min]').forEach(renderProductCardPrice);
    root.querySelectorAll('[data-label-sale][data-badge-detail]').forEach(renderProductCardSaleBadge);
  }

  function initProductCardColorImages(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.main-img[data-color-images]').forEach(function (mainImg) {
      if (mainImg.dataset.colorImagesReady === 'true') return;
      mainImg.dataset.colorImagesReady = 'true';

      var colors;
      try {
        colors = JSON.parse(mainImg.getAttribute('data-color-images'));
      } catch (e) {
        return;
      }
      if (!Array.isArray(colors) || !colors.length) return;

      var frag = document.createDocumentFragment();
      colors.forEach(function (item) {
        if (!item.h || !item.u) return;
        if (mainImg.querySelector('.color-' + item.h)) return;

        var div = document.createElement('div');
        div.className = 'color-image item-product-img ' + item.h + ' color-' + item.h;

        var img = document.createElement('img');
        img.setAttribute('data-src', item.u);
        img.alt = Utilities.cardImageAlt(mainImg);
        img.width = 700;
        img.height = 700;
        img.loading = 'lazy';
        img.decoding = 'async';

        div.appendChild(img);
        frag.appendChild(div);
      });
      mainImg.appendChild(frag);
    });
  }

  function ensureProductCardImageContainer(card, containerId, containerClassName) {
    if (!card) {
      return null;
    }

    let container = card.querySelector('#' + containerId);
    if (container) {
      return container;
    }

    const mainImageWrap = card.querySelector('.main-img');
    if (!mainImageWrap) {
      return null;
    }

    container = document.createElement('div');
    container.id = containerId;
    container.className = containerClassName;
    mainImageWrap.appendChild(container);

    return container;
  }

  function setProductCardImage(container, imageUrl) {
    if (!container || !imageUrl) {
      return null;
    }

    let image = container.querySelector('img');
    if (!image) {
      const placeholder = container.querySelector('.item-product-img__placeholder');

      image = document.createElement('img');
      image.alt = Utilities.cardImageAlt(container);
      image.width = 700;
      image.height = 700;
      image.loading = 'lazy';
      image.decoding = 'async';

      if (placeholder) {
        image.addEventListener('load', function () {
          placeholder.remove();
        }, { once: true });
        image.addEventListener('error', function () {
          placeholder.remove();
        }, { once: true });
      }

      container.appendChild(image);
    }

    image.setAttribute('src', imageUrl);
    if (image.getAttribute('data-src') !== null) {
      image.setAttribute('data-src', imageUrl);
    }
    if (image.getAttribute('data-lazy') !== null) {
      image.setAttribute('data-lazy', imageUrl);
    }

    return image;
  }

  // Cards with the image slider (product-card-slider.js) have no hover image swap:
  // the second image is the next slide instead.
  function isProductCardSlider(card) {
    return !!(card && card.querySelector('[data-card-slider]'));
  }

  function setProductCardSliderImages(card, urls) {
    if (window.ProductCardSlider && isProductCardSlider(card)) {
      window.ProductCardSlider.setImages(card, urls);
    }
  }

  function initSwiperForSlider(slider) {
    if (typeof window.Swiper !== 'function') {
      return;
    }

    if (slider.dataset.swiperReady === 'true') {
      return;
    }

    const track = slider.querySelector('.product-card-colors-track');
    const scrollbar = slider.querySelector('.product-card-colors-scrollbar');
    if (!track || !scrollbar) {
      return;
    }

    const slideCount = track.querySelectorAll('.product-card-color-slide').length;
    if (slideCount <= 1) {
      scrollbar.style.display = 'none';
      slider.dataset.swiperReady = 'false';
      return;
    }

    const swiperInstance = new window.Swiper(slider, {
      wrapperClass: 'product-card-colors-track',
      slideClass: 'product-card-color-slide',
      slidesPerView: 'auto',
      spaceBetween: 7,
      freeMode: {
        enabled: true,
        momentum: true,
        momentumRatio: 1,
        momentumVelocityRatio: 1,
        sticky: false
      },
      mousewheel: {
        enabled: true,
        forceToAxis: false,
        releaseOnEdges: true,
        sensitivity: 1,
        eventsTarget: 'container'
      },
      watchOverflow: true,
      scrollbar: {
        el: scrollbar,
        draggable: true,
        hide: false
      },
      observer: true,
      observeParents: true
    });

    slider.dataset.swiperReady = 'true';
    slider.__productCardColorsSwiper = swiperInstance;
  }

  // the visible text is just "+7", so the accessible name has to spell out what it does
  function setMoreButtonLabel(button, count) {
    if (!button) return;
    const label = 'Show ' + count + ' more colors';
    if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
  }

  // Per-card measure (labels differ per card). The button is display:none until
  // is-visible is added (hidden-by-default so it can't flash before JS layout runs),
  // and hidden it measures 0 — show it first. Measure with the widest possible label
  // so the real "+N" never needs more space than reserved.
  function measureMoreButtonWidth(moreButton, slideCount) {
    moreButton.textContent = '+' + (slideCount - 1);
    setMoreButtonLabel(moreButton, slideCount - 1);
    moreButton.classList.add('is-visible');
    return moreButton.getBoundingClientRect().width || 30;
  }

  // Figures out how many swatches fit alongside the "+N" button.
  function computeSingleRowLayout(wrapper) {
    const slider = wrapper.querySelector('.product-card-colors');
    const track = wrapper.querySelector('.product-card-colors-track');
    const moreButton = wrapper.querySelector('.product-card-colors-more');
    if (!slider || !track || !moreButton) {
      return null;
    }

    const slides = track.querySelectorAll('.product-card-color-slide');
    if (!slides.length) {
      return { moreButton: moreButton, slides: slides, cutoff: 0, showButton: false, hiddenCount: 0 };
    }

    const containerWidth = slider.clientWidth;
    const trackStyle = getComputedStyle(track);
    const gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
    const slideWidth = slides[0].getBoundingClientRect().width;
    const slideCount = slides.length;
    const naturalWidth = slideCount * slideWidth + (slideCount - 1) * gap;

    if (!containerWidth || !slideWidth || naturalWidth <= containerWidth) {
      return { moreButton: moreButton, slides: slides, cutoff: slideCount, showButton: false, hiddenCount: 0 };
    }

    const moreButtonWidth = measureMoreButtonWidth(moreButton, slideCount);
    const available = containerWidth - moreButtonWidth - gap;
    let cutoff = Math.floor((available + gap) / (slideWidth + gap));
    cutoff = Math.max(1, Math.min(cutoff, slideCount - 1));

    return { slider: slider, moreButton: moreButton, slides: slides, cutoff: cutoff, showButton: true, hiddenCount: slideCount - cutoff };
  }

  // Applies a layout plan computed by computeSingleRowLayout.
  function applySingleRowLayout(plan) {
    plan.slides.forEach(function (slide, index) {
      slide.style.display = index < plan.cutoff ? '' : 'none';
    });
    plan.moreButton.classList.toggle('is-visible', plan.showButton);
    if (!plan.showButton) {
      return;
    }
    plan.moreButton.textContent = '+' + plan.hiddenCount;
    setMoreButtonLabel(plan.moreButton, plan.hiddenCount);

    // Geometry self-check: whatever the math missed (sub-pixel rounding, late font
    // swap), if the button still pokes past the row, shave swatches until it fits.
    if (!plan.slider) {
      return;
    }
    let cutoff = plan.cutoff;
    const rowRight = plan.slider.getBoundingClientRect().right;
    while (cutoff > 1 && plan.moreButton.getBoundingClientRect().right > rowRight + 0.5) {
      cutoff -= 1;
      plan.slides[cutoff].style.display = 'none';
      plan.moreButton.textContent = '+' + (plan.slides.length - cutoff);
      setMoreButtonLabel(plan.moreButton, plan.slides.length - cutoff);
    }
  }

  function layoutSingleRowSwatches(wrapper) {
    const plan = computeSingleRowLayout(wrapper);
    if (plan) {
      applySingleRowLayout(plan);
    }
  }

  let singleRowResizeObserver = null;
  const pendingSingleRowWrappers = new Set();
  let singleRowResizeFrame = null;

  function flushSingleRowResize() {
    singleRowResizeFrame = null;

    const plans = [];
    pendingSingleRowWrappers.forEach(function (wrapper) {
      if (wrapper.dataset.expanded === 'true') {
        return;
      }
      const plan = computeSingleRowLayout(wrapper);
      if (plan) {
        plans.push(plan);
      }
    });
    pendingSingleRowWrappers.clear();
    plans.forEach(applySingleRowLayout);
  }

  function getSingleRowResizeObserver() {
    if (singleRowResizeObserver) {
      return singleRowResizeObserver;
    }

    if (typeof ResizeObserver !== 'function') {
      window.addEventListener('resize', function () {
        if (singleRowResizeFrame) {
          return;
        }
        singleRowResizeFrame = requestAnimationFrame(function () {
          singleRowResizeFrame = null;
          document.querySelectorAll('.product-card-colors-wrapper[data-single-row="true"]:not([data-expanded="true"])').forEach(layoutSingleRowSwatches);
        });
      });
      singleRowResizeObserver = { observe: function () {}, unobserve: function () {} };
      return singleRowResizeObserver;
    }

    singleRowResizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        const wrapper = entry.target.closest('.product-card-colors-wrapper');
        if (wrapper) {
          pendingSingleRowWrappers.add(wrapper);
        }
      });

      if (singleRowResizeFrame) {
        cancelAnimationFrame(singleRowResizeFrame);
      }
      singleRowResizeFrame = requestAnimationFrame(flushSingleRowResize);
    });

    return singleRowResizeObserver;
  }

  function setupSingleRowSwatches(wrapper, slider) {
    const moreButton = wrapper.querySelector('.product-card-colors-more');
    if (!moreButton) {
      return;
    }

    layoutSingleRowSwatches(wrapper);

    if (wrapper.dataset.singleRowReady === 'true') {
      return;
    }
    wrapper.dataset.singleRowReady = 'true';

    moreButton.addEventListener('click', function () {
      wrapper.dataset.expanded = 'true';
      getSingleRowResizeObserver().unobserve(slider);

      const track = slider.querySelector('.product-card-colors-track');
      if (track) {
        track.querySelectorAll('.product-card-color-slide').forEach(function (slide) {
          slide.style.removeProperty('display');
        });
      }

      moreButton.remove();
      initSwiperForSlider(slider);
    });

    getSingleRowResizeObserver().observe(slider);
  }

  function initProductCardColorSwipers(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const colorSliders = [];
    if (root.matches && root.matches('.product-card-colors')) {
      colorSliders.push(root);
    }
    root.querySelectorAll('.product-card-colors').forEach(function (slider) {
      colorSliders.push(slider);
    });

    colorSliders.forEach(function (slider) {
      const wrapper = slider.closest('.product-card-colors-wrapper');

      if (wrapper && wrapper.dataset.singleRow === 'true' && wrapper.dataset.expanded !== 'true') {
        setupSingleRowSwatches(wrapper, slider);
        return;
      }

      initSwiperForSlider(slider);
    });
  }

  function startProductCardUI() {
    initProductCardColorImages(document);
    initProductCardColorSwipers(document);
    initProductCardPricesAndBadges(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startProductCardUI);
  } else {
    startProductCardUI();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const scope = event.target || document;
    initProductCardColorImages(scope);
    initProductCardColorSwipers(scope);
    initProductCardPricesAndBadges(scope);
  });

  const productCardColorsObserver = new MutationObserver(function (mutations) {
    let scope = null;

    mutations.forEach(function (mutation) {
      if (scope) {
        return;
      }
      mutation.addedNodes.forEach(function (node) {
        if (scope || !node || node.nodeType !== 1) {
          return;
        }

        if (
          (node.matches && (node.matches('.product-card-colors') || node.matches('.grid-item'))) ||
          (node.querySelector && node.querySelector('.product-card-colors, .grid-item'))
        ) {
          scope = mutation.target || document;
        }
      });
    });

    if (scope) {
      initProductCardColorImages(scope);
      initProductCardColorSwipers(scope);
      initProductCardPricesAndBadges(scope);
    }
  });

  if (document.body) {
    productCardColorsObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  let hasScrollbarFocus = false;

  document.addEventListener('pointerdown', function (event) {
    const scrollbar = event.target.closest('.product-card-colors-scrollbar');
    if (!scrollbar) {
      return;
    }

    const wrapper = scrollbar.closest('.product-card-colors-wrapper');
    if (!wrapper) {
      return;
    }

    wrapper.classList.add('is-scrollbar-focus');
    hasScrollbarFocus = true;
  });

  function clearProductCardScrollbarFocus() {
    if (!hasScrollbarFocus) {
      return;
    }
    hasScrollbarFocus = false;
    document.querySelectorAll('.product-card-colors-wrapper.is-scrollbar-focus').forEach(function (wrapper) {
      wrapper.classList.remove('is-scrollbar-focus');
    });
  }

  document.addEventListener('pointerup', clearProductCardScrollbarFocus);
  document.addEventListener('pointercancel', clearProductCardScrollbarFocus);

  document.addEventListener('click', function (event) {
    const swatchButton = event.target.closest('.product-card-color-option');
    if (!swatchButton) {
      return;
    }

    if (swatchButton.closest('product-recommendations')) {
      return;
    }

    const card = swatchButton.closest('.item-product');
    if (!card) {
      return;
    }

    const allSwatches = card.querySelectorAll('.product-card-color-option');
    allSwatches.forEach(function (button) {
      button.classList.remove('active');
    });
    swatchButton.classList.add('active');

    const variantImage = swatchButton.getAttribute('data-image');
    const hoverImage = swatchButton.getAttribute('data-hover-image');
    const itemImageWrapper = card.querySelector('.item-img');

    if (variantImage) {
      setProductCardImage(card.querySelector('#item-product-img'), variantImage);
    }

    if (variantImage && isProductCardSlider(card)) {
      let sliderImages = null;
      try {
        sliderImages = JSON.parse(swatchButton.getAttribute('data-images') || 'null');
      } catch (error) {
        sliderImages = null;
      }
      if (!Array.isArray(sliderImages) || !sliderImages.length) {
        sliderImages = hoverImage && hoverImage !== variantImage ? [variantImage, hoverImage] : [variantImage];
      }
      setProductCardSliderImages(card, sliderImages);
    } else if (variantImage) {
      const hoverImageContainer = ensureProductCardImageContainer(
        card,
        'item-product-img-hover',
        'hover-img item-product-img'
      );
      if (hoverImage && hoverImage !== variantImage) {
        setProductCardImage(hoverImageContainer, hoverImage);
        if (itemImageWrapper) {
          itemImageWrapper.classList.add('has-hover');
        }
      } else {
        setProductCardImage(hoverImageContainer, variantImage);
        if (itemImageWrapper) {
          itemImageWrapper.classList.remove('has-hover');
        }
      }
    }

    const priceContainer = card.querySelector('[data-price-container]');
    if (priceContainer) {
      const selectedPrice = swatchButton.getAttribute('data-price');
      const selectedCompareAtPrice = swatchButton.getAttribute('data-compare-at-price');
      const saleColor = priceContainer.getAttribute('data-sale-color') || '';
      priceContainer.innerHTML = renderCardPrice(selectedPrice, selectedCompareAtPrice, saleColor);
    }

    const variantUrl = swatchButton.getAttribute('data-variant-url');
    if (variantUrl) {
      const productLinks = card.querySelectorAll('.product-card-link');
      productLinks.forEach(function (link) {
        link.setAttribute('href', variantUrl);
      });
    }

    const selectedVariantId = swatchButton.getAttribute('data-variant-id');
    if (selectedVariantId) {
      card.setAttribute('data-current-variant-id', selectedVariantId);

      const quickAddScopes = card.querySelectorAll('.item-quick-add, .item-quick-add__button');
      quickAddScopes.forEach(function (scope) {
        scope.setAttribute('data-current-variant-id', selectedVariantId);
      });

      if (typeof window.__refreshProductCardSizesForColor === 'function') {
        window.__refreshProductCardSizesForColor(card);
      }
    }

  });
}

if (!window.__PRODUCT_GRID_INIT__) {
  window.__PRODUCT_GRID_INIT__ = true;
  function initProductGridFallback() {
    const variantsCache = new Map();
    const IMAGE_WIDTH = 700;
    // cards are hydrated through a bounded queue, so a card queued but not yet started
    // is no longer marked by its dataset flag - this set keeps a second pass off it
    const queuedItems = new Set();
    const MAX_PARALLEL_ITEMS = 8;
    const slotWaiters = [];
    let activeSlots = 0;

    function acquireSlot() {
      if (activeSlots < MAX_PARALLEL_ITEMS) {
        activeSlots++;
        return Promise.resolve();
      }
      return new Promise(function (resolve) { slotWaiters.push(resolve); });
    }

    function releaseSlot() {
      const next = slotWaiters.shift();
      // hand the slot straight over instead of releasing it, so the cap holds
      if (next) next();
      else activeSlots--;
    }

    let scanTimeout = null;
    let wishlistReloadTimeout = null;

    function hasSmartWishlist(scope = document) {
      if (!scope) {
        return false;
      }

      if (scope.matches && scope.matches('.smartwishlist')) {
        return true;
      }

      return !!(scope.querySelector && scope.querySelector('.smartwishlist'));
    }

    function reloadSmartWishlist(scope = document) {
      if (!hasSmartWishlist(scope)) {
        return;
      }

      if (typeof window.ReloadSmartWishlist === 'function') {
        window.ReloadSmartWishlist();
      }
    }

    function scheduleWishlistReload(scope = document) {
      if (wishlistReloadTimeout) {
        clearTimeout(wishlistReloadTimeout);
      }

      wishlistReloadTimeout = setTimeout(function () {
        reloadSmartWishlist(scope);
      }, 120);
    }

    function isRelevantGridMutationNode(node) {
      if (!node || node.nodeType !== 1) {
        return false;
      }

      if (
        (node.matches && node.matches('.smartwishlist')) ||
        (node.closest && node.closest('.smartwishlist'))
      ) {
        return false;
      }

      if (
        (node.matches && node.matches('.grid-item, .product-card-colors, .product-card-color-slide, .product-card-color-option')) ||
        (node.querySelector && node.querySelector('.grid-item, .product-card-colors, .product-card-color-slide, .product-card-color-option'))
      ) {
        return true;
      }

      return false;
    }

    function getSizedImageUrl(url) {
      if (!url) return '';

      try {
        const parsed = new URL(url);
        parsed.searchParams.set('width', String(IMAGE_WIDTH));
        return parsed.toString();
      } catch (error) {
        return url;
      }
    }

    function normalizeImageUrl(url) {
      if (!url) return '';

      try {
        const parsed = new URL(url, window.location.origin);
        return parsed.toString();
      } catch (error) {
        return url;
      }
    }

    function shouldMatchFilteredColorImages(productEl) {
      return !!(productEl && productEl.dataset.matchFilteredColorImages === 'true');
    }

    function isColorSearchPage() {
      return document.documentElement.classList.contains('search-by-color');
    }

    function getColorSearchKey(productEl) {
      if (!isColorSearchPage()) {
        return '';
      }
      return normalizeColorToken((productEl && productEl.dataset.colorSearch) || '');
    }

    function getRequestedColorKey(productEl, allVariants) {
      const requestedVariantId = productEl && productEl.dataset ? productEl.dataset.requestedVariantId : '';
      if (!requestedVariantId || !Array.isArray(allVariants)) {
        return '';
      }

      const match = allVariants.find(function (variant) {
        return parseVariantIdFromGid(variant.id) === String(requestedVariantId);
      });
      if (!match) {
        return '';
      }

      const colorOpt = (match.selectedOptions || []).find(function (option) {
        return option && option.name && option.value && option.name.toLowerCase().indexOf('color') !== -1;
      });

      return colorOpt ? normalizeColorToken(colorOpt.value) : '';
    }

    function getFilteredColorKeys(productEl) {
      const uniqueKeys = [];

      if (shouldMatchFilteredColorImages(productEl)) {
        const rawValue = String(productEl.dataset.filteredColor || '');
        rawValue.split('|').forEach(function (rawColor) {
          const normalizedKey = normalizeColorToken(rawColor);
          if (!normalizedKey) {
            return;
          }

          if (uniqueKeys.indexOf(normalizedKey) === -1) {
            uniqueKeys.push(normalizedKey);
          }
        });

        // An explicit Color filter takes precedence — don't mix in the search color.
        return uniqueKeys;
      }

      const colorSearchKey = getColorSearchKey(productEl);
      if (colorSearchKey && uniqueKeys.indexOf(colorSearchKey) === -1) {
        uniqueKeys.push(colorSearchKey);
      }

      return uniqueKeys;
    }

    function getFilteredColorPriorityMap(filteredColorKeys) {
      const priorityMap = new Map();
      if (!Array.isArray(filteredColorKeys)) {
        return priorityMap;
      }

      filteredColorKeys.forEach(function (colorKey, index) {
        if (colorKey) {
          priorityMap.set(colorKey, index);
        }
      });

      return priorityMap;
    }

    function scheduleProcessItems(root = document) {
      if (scanTimeout) clearTimeout(scanTimeout);

      scanTimeout = setTimeout(() => {
        processItems(root);
      }, 120);
    }

    async function processItems(root = document) {
      let itemsSelector = '.grid-item[data-needs-metafield-fallback="true"], .grid-item[data-match-filtered-color-images="true"], .grid-item[data-needs-size-fetch="true"]';
      if (isColorSearchPage()) {
        itemsSelector += ', .grid-item[data-color-search]';
      }
      const rawItems = root.querySelectorAll(itemsSelector);

      if (!rawItems.length) {
        scheduleWishlistReload(root);
        return;
      }

      const uniqueItems = Array.from(rawItems).filter(
        function (item) { return !item.closest('.swiper-slide-duplicate'); }
      );
      const runItem = async (item) => {
        if (!item || item.dataset.imagesLoaded === 'true' || item.dataset.imagesLoading === 'true') return;

        const needsFallback = item.dataset.needsMetafieldFallback === 'true';
        const needsFilteredColorCheck = item.dataset.matchFilteredColorImages === 'true';
        const needsColorSearchCheck = !!getColorSearchKey(item);
        const needsSizeFetch = item.dataset.needsSizeFetch === 'true';
        if (!needsFallback && !needsFilteredColorCheck && !needsColorSearchCheck && !needsSizeFetch) {
          item.dataset.imagesLoaded = 'true';
          return;
        }

        item.dataset.imagesLoading = 'true';

        const container = item.querySelector('#item-product-img');
        if (!container) {
          item.dataset.imagesLoaded = 'true';
          delete item.dataset.imagesLoading;
          return;
        }

        const rawId = item.getAttribute('id');
        if (!rawId) {
          delete item.dataset.imagesLoading;
          return;
        }

        const numericId = rawId.replace(/\D+/g, '');
        if (!numericId) {
          delete item.dataset.imagesLoading;
          return;
        }

        try {
          const gid = `gid://shopify/Product/${numericId}`;
          const { variants, productData } = await fetchAllVariants(gid);
          if (needsFallback || needsFilteredColorCheck || needsColorSearchCheck) {
            await renderColors(variants, item, productData);
          }
          if (needsSizeFetch) {
            renderMissingCardSizes(variants, item);
          }
          injectQuickAddData(item, numericId, variants, productData);
          item.dataset.imagesLoaded = 'true';
          item.dataset.needsMetafieldFallback = 'false';
        } catch (err) {
          console.error('[product-card] processItem failed for', numericId, err);
          // Clear skeleton if the fetch failed before renderColors ran.
          const failContainer = item.querySelector('#item-product-img');
          if (failContainer) failContainer.classList.remove('is-resolving');
        } finally {
          delete item.dataset.imagesLoading;
        }
      };

      const viewportDistance = (el) => {
        const rect = el.getBoundingClientRect();
        if (rect.bottom >= 0 && rect.top <= window.innerHeight) return 0;
        return rect.top > window.innerHeight ? rect.top - window.innerHeight : -rect.bottom;
      };

      const queue = uniqueItems
        .filter(function (item) { return !queuedItems.has(item); })
        .map(function (item, index) {
          queuedItems.add(item);
          return { item: item, index: index, distance: viewportDistance(item) };
        })
        .sort(function (a, b) { return a.distance - b.distance || a.index - b.index; });

      await Promise.all(queue.map(async function (entry) {
        await acquireSlot();
        try {
          await runItem(entry.item);
        } finally {
          releaseSlot();
          queuedItems.delete(entry.item);
        }
      }));

      if (typeof updateProductCount === 'function') updateProductCount();
      scheduleWishlistReload(root);
    }

    async function fetchAllVariants(id) {
      if (variantsCache.has(id)) {
        return variantsCache.get(id);
      }

      const all = [];
      let productData = null;
      let cursor = null;
      let hasNext = true;

      while (hasNext) {
        const isFirstPage = cursor === null;
        const productLevelFields = isFirstPage ? `
              title
              handle
              options { name values }
              priceRange { minVariantPrice { amount } }
              images(first: 20) {
                edges { node { url(transform: {maxWidth: 1024}) altText } }
              }` : '';

        const query = `
          query ($id: ID!, $cursor: String) {
            node(id: $id) {
              ... on Product {
                ${productLevelFields}
                variants(first: 250, after: $cursor) {
                  edges {
                    cursor
                    node {
                      id
                      title
                      availableForSale
                      quantityAvailable
                      price {
                        amount
                      }
                      compareAtPrice {
                        amount
                      }
                      image {
                        url
                      }
                      selectedOptions {
                        name
                        value
                      }
                      active: metafield(namespace: "custom", key: "active") {
                        value
                      }
                      liveColor: metafield(namespace: "live", key: "color") {
                        value
                      }
                      images: metafield(namespace: "custom", key: "images") {
                        references(first: 20) {
                          edges {
                            node {
                              ... on MediaImage {
                                image {
                                  url
                                }
                              }
                              ... on GenericFile {
                                previewImage {
                                  url
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  pageInfo {
                    endCursor
                    hasNextPage
                  }
                }
              }
            }
          }
        `;

        let json;
        try {
          const res = await fetch(
            ((window.LIVE && window.LIVE.storefrontUrl) || "https://live-ecom.myshopify.com/api/2025-07/graphql.json"),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': ((window.LIVE && window.LIVE.storefrontToken) || 'ed761c0d0f68bc596e5e4dd4e29e6407')
              },
              body: JSON.stringify({
                query,
                variables: { id, cursor }
              })
            }
          );
          if (!res.ok) {
            console.error('[product-card] fetchAllVariants HTTP', res.status, id);
            hasNext = false;
            continue;
          }
          json = await res.json();
        } catch (networkErr) {
          console.error('[product-card] fetchAllVariants network error', id, networkErr);
          hasNext = false;
          continue;
        }

        const node = json?.data?.node;
        if (!node) {
          hasNext = false;
          continue;
        }

        if (isFirstPage && !productData) {
          productData = {
            title: node.title || '',
            handle: node.handle || '',
            options: (node.options || []).map(function (o) { return { name: o.name, values: o.values }; }),
            images: ((node.images || {}).edges || []).map(function (e) {
              return { url: e.node.url, altText: e.node.altText || '' };
            }),
            priceMin: node.priceRange ? moneyAmountToCents(node.priceRange.minVariantPrice.amount) : 0
          };
        }

        const variants = node.variants;
        if (!variants) {
          hasNext = false;
          continue;
        }

        variants.edges.forEach((edge) => {
          all.push(edge.node);
        });

        cursor = variants.pageInfo && variants.pageInfo.endCursor ? variants.pageInfo.endCursor : null;
        hasNext = variants.pageInfo.hasNextPage;

        if (hasNext && !cursor) {
          hasNext = false;
        }
      }

      const result = { variants: all, productData };
      variantsCache.set(id, result);
      if (productData?.handle) {
        window.__quickAddVariantsCache = window.__quickAddVariantsCache || {};
        window.__quickAddVariantsCache[productData.handle] = all;
      }
      return result;
    }

    function injectQuickAddData(card, numericProductId, variants, productData) {
      const sizesContainer = card.querySelector('.product-card-sizes');
      // Only build this payload when the quickshop popup is actually reachable: the classic
      // quick-add button always needs it, and sizes need it unless they're in pure
      // add-to-cart mode (data-add-to-cart="true"), where the popup is never opened.
      const needsPopupData = !!card.querySelector('.item-quick-add__button') ||
        (!!sizesContainer && sizesContainer.getAttribute('data-add-to-cart') !== 'true');
      if (!needsPopupData) return;

      const existingTag = document.getElementById('quick-add-product-data-' + numericProductId);
      if (existingTag) return;

      if (!productData || !variants || !variants.length) return;

      const optionNames = (productData.options || []).map(function (o) { return o.name; });

      const transformedVariants = variants.map(function (v) {
        const numId = parseInt(parseVariantIdFromGid(v.id), 10);
        const opts = v.selectedOptions || [];
        return {
          id: numId,
          title: opts.map(function (o) { return o.value; }).join(' / '),
          option1: opts[0] ? opts[0].value : null,
          option2: opts[1] ? opts[1].value : null,
          option3: opts[2] ? opts[2].value : null,
          available: v.availableForSale,
          price: moneyAmountToCents(v.price ? v.price.amount : '0'),
          compare_at_price: v.compareAtPrice ? moneyAmountToCents(v.compareAtPrice.amount) : null
        };
      });

      const availableVariant = transformedVariants.find(function (v) { return v.available; }) || transformedVariants[0] || null;

      const payload = {
        product: {
          id: parseInt(numericProductId, 10),
          title: productData.title || '',
          handle: productData.handle || '',
          price: productData.priceMin || (transformedVariants[0] ? transformedVariants[0].price : 0),
          options: optionNames,
          variants: transformedVariants,
          media: (productData.images || []).map(function (img) {
            return { src: img.url, alt: img.altText || '' };
          })
        },
        selected_or_first_available_variant: availableVariant,
        variants_inventory: variants.map(function (v) {
          return {
            id: parseInt(parseVariantIdFromGid(v.id), 10),
            inventory_quantity: typeof v.quantityAvailable === 'number' ? v.quantityAvailable : 0
          };
        })
      };

      const script = document.createElement('script');
      script.type = 'application/json';
      script.id = 'quick-add-product-data-' + numericProductId;
      script.textContent = JSON.stringify(payload);
      card.appendChild(script);
    }

    function parseVariantIdFromGid(gid) {
      if (!gid) {
        return '';
      }

      const parts = String(gid).split('/');
      return parts[parts.length - 1] || '';
    }

    function moneyAmountToCents(amount) {
      const parsed = Number(amount);
      if (!Number.isFinite(parsed)) {
        return 0;
      }

      return Math.round(parsed * 100);
    }

    function buildVariantUrl(baseHref, variantId) {
      if (!baseHref || !variantId) {
        return baseHref || '';
      }

      try {
        const normalizedUrl = new URL(baseHref, window.location.origin);
        normalizedUrl.searchParams.set('variant', variantId);

        if (/^https?:\/\//i.test(baseHref)) {
          return normalizedUrl.toString();
        }

        return normalizedUrl.pathname + normalizedUrl.search + normalizedUrl.hash;
      } catch (error) {
        const separator = baseHref.indexOf('?') === -1 ? '?' : '&';
        return baseHref + separator + 'variant=' + variantId;
      }
    }

    function isVariantVisibleByActiveMetafield(variant) {
      const activeRaw = variant && variant.active && variant.active.value;
      if (activeRaw === null || activeRaw === undefined || activeRaw === '') {
        return true;
      }

      const normalized = String(activeRaw).trim().toLowerCase();
      if (normalized === 'false' || normalized === '0') {
        return false;
      }

      return normalized === 'true' || normalized === '1';
    }

    function normalizeColorToken(colorValue) {
      return String(colorValue || '')
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');
    }

    function getVariantFilteredColorPriority(variant, filteredColorKeys, colorValue) {
      if (!Array.isArray(filteredColorKeys) || !filteredColorKeys.length) {
        return -1;
      }

      const liveColorValue = variant && variant.liveColor && variant.liveColor.value;
      const liveColorKey = normalizeColorToken(liveColorValue || '');
      const optionColorKey = normalizeColorToken(colorValue || '');

      let bestPriority = -1;
      filteredColorKeys.forEach(function (filteredColorKey, index) {
        if (!filteredColorKey) {
          return;
        }

        const isMatch = (liveColorKey && liveColorKey.indexOf(filteredColorKey) !== -1) || optionColorKey === filteredColorKey;
        if (isMatch && index > bestPriority) {
          bestPriority = index;
        }
      });

      return bestPriority;
    }

    function variantMatchesFilteredColor(variant, filteredColorKeys, colorValue) {
      return getVariantFilteredColorPriority(variant, filteredColorKeys, colorValue) !== -1;
    }

    function getButtonFilteredColorPriority(btnColorKey, liveColorKey, filteredColorPriorityMap) {
      if (!(filteredColorPriorityMap instanceof Map) || !filteredColorPriorityMap.size) {
        return -1;
      }

      let bestPriority = -1;
      filteredColorPriorityMap.forEach(function (priority, filteredColorKey) {
        const isMatch = (liveColorKey && liveColorKey.indexOf(filteredColorKey) !== -1) ||
          btnColorKey === filteredColorKey ||
          btnColorKey.indexOf(filteredColorKey) !== -1;

        if (isMatch && priority > bestPriority) {
          bestPriority = priority;
        }
      });

      return bestPriority;
    }

    function getVariantImageCandidates(variant) {
      const urls = [];

      if (variant && variant.image && variant.image.url) {
        urls.push(variant.image.url);
      }

      const imageEdges = variant && variant.images && variant.images.references && variant.images.references.edges;
      if (Array.isArray(imageEdges)) {
        imageEdges.forEach(function (edge) {
          const node = edge && edge.node;
          const url = (node && node.image && node.image.url) ||
                      (node && node.previewImage && node.previewImage.url);
          if (url) {
            urls.push(url);
          }
        });
      }

      return Array.from(new Set(urls.filter(Boolean)));
    }

    function getCustomImageCandidates(variant) {
      const imageEdges = variant && variant.images && variant.images.references && variant.images.references.edges;
      if (!Array.isArray(imageEdges)) {
        return [];
      }
      const urls = [];
      imageEdges.forEach(function (edge) {
        const node = edge && edge.node;
        const url = (node && node.image && node.image.url) ||
                    (node && node.previewImage && node.previewImage.url);
        if (url) {
          urls.push(url);
        }
      });
      return Array.from(new Set(urls.filter(Boolean)));
    }

    function imageFilename(url) {
      if (!url) return '';
      const clean = String(url).split('?')[0].split('#')[0];
      const parts = clean.split('/');
      return parts[parts.length - 1] || '';
    }

    // Strips the trailing sequence index (e.g. "..._1.jpg" -> "...") so the main
    // image and its sibling images of the same color share one base key.
    function imageBaseKey(url) {
      return imageFilename(url).replace(/_\d+(\.[a-z0-9]+)?$/i, '').toLowerCase();
    }

    // On a color-search page the SSR already rendered the correct main image, but
    // when the product has custom-image metafields SSR leaves the hover slot as a
    // placeholder for JS to fill. Find a second image of the SAME color (matched by
    // file base key, which is robust to color-option vs SKU-code mismatches) and
    // drop it into the hover container.
    function getColorSearchMainUrl(productEl, container) {
      const mainImgEl = container.querySelector('img');
      return mainImgEl
        ? (mainImgEl.getAttribute('data-src') || mainImgEl.getAttribute('data-lazy') || mainImgEl.getAttribute('src') || '')
        : (productEl.dataset.colorSearchImage || '');
    }

    // Every other image of the main image's color, matched by file base key.
    function getSameColorImageUrls(allVariants, mainUrl) {
      const baseKey = imageBaseKey(mainUrl);
      if (!baseKey) return [];
      const mainName = imageFilename(mainUrl);
      const urls = [];
      const names = [mainName];
      (allVariants || []).forEach(function (variant) {
        getCustomImageCandidates(variant).concat(getVariantImageCandidates(variant)).forEach(function (url) {
          const name = imageFilename(url);
          if (imageBaseKey(url) === baseKey && names.indexOf(name) === -1) {
            names.push(name);
            urls.push(url);
          }
        });
      });
      return urls;
    }

    // Image slider counterpart of fillColorSearchHover: the SSR main image first, then
    // the rest of that color's images — the custom.images list of the variant the main
    // image belongs to (as on the PDP), else the images matched by file base key.
    function getColorSearchImages(allVariants, productEl, container) {
      const mainUrl = getColorSearchMainUrl(productEl, container);
      if (!mainUrl) return [];
      const mainName = imageFilename(mainUrl);
      let ownerImages = [];
      (allVariants || []).some(function (variant) {
        const urls = getCustomImageCandidates(variant);
        const ownsMain = urls.some(function (url) {
          return imageFilename(url) === mainName;
        });
        if (ownsMain) ownerImages = urls;
        return ownsMain;
      });
      const rest = ownerImages.length
        ? ownerImages.filter(function (url) { return imageFilename(url) !== mainName; })
        : getSameColorImageUrls(allVariants, mainUrl);
      return [mainUrl].concat(rest.map(getSizedImageUrl));
    }

    function fillColorSearchHover(allVariants, productEl, container, containerHover) {
      if (!container || !containerHover) return;
      if (containerHover.querySelector('img')) return; // hover already rendered by SSR

      const mainUrl = getColorSearchMainUrl(productEl, container);
      if (!mainUrl) return;

      const itemWrap = productEl.querySelector('.item-img');
      let hoverUrl = productEl.dataset.colorSearchHover || '';

      if (!hoverUrl) {
        hoverUrl = getSameColorImageUrls(allVariants, mainUrl)[0] || '';
      }

      if (hoverUrl) {
        const placeholder = containerHover.querySelector('.item-product-img__placeholder');
        if (placeholder) placeholder.remove();
        setProductCardImage(containerHover, getSizedImageUrl(hoverUrl));
        if (itemWrap) itemWrap.classList.add('has-hover');
      } else if (itemWrap) {
        // No distinct second image for this color: no hover-swap effect.
        itemWrap.classList.remove('has-hover');
      }
    }

    function pickExactVariantImage(variant, colorValue) {
      const candidates = getVariantImageCandidates(variant);
      if (!candidates.length) {
        return '';
      }

      const colorToken = normalizeColorToken(colorValue);
      if (!colorToken) {
        return '';
      }

      return candidates.find(function (url) {
        return normalizeColorToken(url).indexOf(colorToken) !== -1;
      }) || '';
    }

    function getVariantOptionValue(variant, optionName) {
      const opt = (variant.selectedOptions || []).find(function (option) {
        return option && option.name && option.name.toLowerCase() === optionName;
      });
      return opt ? opt.value : '';
    }

    function isVariantSelectableForCard(variant) {
      return !!(variant && variant.availableForSale && isVariantVisibleByActiveMetafield(variant));
    }

    function getCurrentColorForCard(productEl, container, allVariants) {
      const currentVariantId = productEl.getAttribute('data-current-variant-id') || container.getAttribute('data-current-variant-id') || '';
      const numericCurrentId = String(currentVariantId).split('/').pop();
      if (!numericCurrentId) {
        return '';
      }
      const currentVariant = allVariants.find(function (v) { return String(v.id || '').split('/').pop() === numericCurrentId; });
      return currentVariant ? getVariantOptionValue(currentVariant, 'color') : '';
    }

    // Sizes are filtered against the card's CURRENTLY DISPLAYED color (via
    // data-current-variant-id), so switching color swatches re-renders this to reflect
    // that color's real stock instead of aggregating availability across every color.
    function renderMissingCardSizes(allVariants, productEl) {
      const container = productEl.querySelector('.product-card-sizes');
      const track = container ? container.querySelector('.product-card-sizes-track') : null;
      if (!container || !track || !allVariants || !allVariants.length) {
        return;
      }

      const currentColorValue = getCurrentColorForCard(productEl, container, allVariants);

      const orderRaw = container.getAttribute('data-size-order') || '';
      const nativeOrder = orderRaw ? orderRaw.split('||').filter(Boolean) : [];

      const seenSizes = [];
      const availableSizes = new Set();
      allVariants.forEach(function (variant) {
        const size = getVariantOptionValue(variant, 'size');
        if (!size) {
          return;
        }
        if (seenSizes.indexOf(size) === -1) {
          seenSizes.push(size);
        }
        const matchesCurrentColor = !currentColorValue || getVariantOptionValue(variant, 'color') === currentColorValue;
        if (matchesCurrentColor && isVariantSelectableForCard(variant)) {
          availableSizes.add(size);
        }
      });

      if (!seenSizes.length) {
        container.style.display = 'none';
        return;
      }
      container.style.display = '';
      container.dataset.sizesReady = 'true';

      const orderedSizes = nativeOrder
        .filter(function (size) { return seenSizes.indexOf(size) !== -1; })
        .concat(seenSizes.filter(function (size) { return nativeOrder.indexOf(size) === -1; }));

      track.innerHTML = '';
      orderedSizes.forEach(function (size) {
        const available = availableSizes.has(size);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-card-size-option' + (available ? '' : ' sold-out');
        button.setAttribute('data-size', size);
        button.setAttribute('role', 'listitem');
        if (available) {
          button.setAttribute('aria-label', 'Select size ' + size);
        } else {
          button.disabled = true;
          button.setAttribute('aria-label', size + ' - out of stock');
        }
        button.textContent = size;
        track.appendChild(button);
      });
    }

    // Bridge so the color-swatch click handler (a separate top-level script block with its
    // own closure) can ask the sizes row to re-render for the newly selected color, since
    // renderMissingCardSizes/variantsCache live inside this closure.
    window.__refreshProductCardSizesForColor = function (productEl) {
      const rawId = productEl.getAttribute('id') || '';
      const numericId = rawId.replace(/\D+/g, '');
      if (!numericId) {
        return;
      }
      const cached = variantsCache.get(`gid://shopify/Product/${numericId}`);
      if (cached && cached.variants && cached.variants.length) {
        renderMissingCardSizes(cached.variants, productEl);
      }
    };

    // strict=true only returns a variant matching the CURRENTLY DISPLAYED color (or null) —
    // used to guard direct add-to-cart so it never silently substitutes a different color
    // than what the shopper is looking at. strict=false allows falling back to any color,
    // which is fine for the quickshop popup path since the shopper can adjust it there.
    function resolveVariantForSize(variants, size, currentVariantId, strict) {
      const numericCurrentId = String(currentVariantId || '').split('/').pop();
      const currentVariant = numericCurrentId
        ? variants.find(function (v) { return String(v.id || '').split('/').pop() === numericCurrentId; })
        : null;
      const currentColorValue = currentVariant ? getVariantOptionValue(currentVariant, 'color') : '';

      const matchesSize = function (v) { return getVariantOptionValue(v, 'size') === size; };
      const matchesColor = function (v) {
        return !currentColorValue || getVariantOptionValue(v, 'color') === currentColorValue;
      };

      const exact = variants.find(function (v) { return matchesSize(v) && matchesColor(v) && isVariantSelectableForCard(v); });
      if (exact || strict) {
        return exact || null;
      }

      return (
        variants.find(function (v) { return matchesSize(v) && isVariantSelectableForCard(v); }) ||
        variants.find(function (v) { return matchesSize(v) && matchesColor(v); }) ||
        variants.find(matchesSize) ||
        null
      );
    }

    // Every image of one color — the single JS copy of the rule, kept in step with the
    // slider_urls block in item-product.liquid and with the PDP (Lemonade.changeVariant):
    // the color's custom.images metafield list; otherwise the color's variant image followed
    // by the product images whose URL contains the color value (lowercased, leading zeros
    // stripped). preferredImage always comes from the variant's own images, never from the
    // product's first image, so unlike the Liquid fallback it can't be another color and stays
    // in the lead (slide 0 is set from that same image). Used by the swatches and by
    // renderColors. SKU color search is the one
    // exception: there the images are matched by file base key (getColorSearchImages).
    // entry: { colorValue, customFallbackImages, fallbackImages, preferredImage? }
    function getColorImages(entry, productData) {
      if (entry.customFallbackImages.length) {
        return entry.customFallbackImages.map(getSizedImageUrl);
      }

      const urls = entry.preferredImage ? [entry.preferredImage] : [];
      const seen = urls.map(imageFilename);
      const colorToken = String(entry.colorValue || '').toLowerCase().replace(/^0+/, '');
      const productImages = (productData && productData.images) || [];
      if (colorToken) {
        productImages.forEach(function (image) {
          const url = image && image.url;
          const name = imageFilename(url);
          if (url && url.toLowerCase().indexOf(colorToken) !== -1 && seen.indexOf(name) === -1) {
            seen.push(name);
            urls.push(url);
          }
        });
      }

      return (urls.length ? urls : entry.fallbackImages.slice(0, 1)).map(getSizedImageUrl);
    }

    function renderMissingCardColors(allVariants, productEl, productData) {
      const slider = productEl.querySelector('.product-card-colors');
      const track = productEl.querySelector('.product-card-colors-track');
      if (!slider || !track || !allVariants || !allVariants.length) {
        return;
      }

      const filteredColorKeys = getFilteredColorKeys(productEl);
      const filteredColorPriorityMap = getFilteredColorPriorityMap(filteredColorKeys);
      const mainColorKey = !filteredColorKeys.length ? normalizeColorToken(productEl.dataset.mainColor || '') : '';
      const colorSearchKey = !filteredColorKeys.length ? normalizeColorToken(productEl.dataset.colorSearchSku || '') : '';

      const availableVisibleVariantIds = new Set();
      const availableVisibleColors = new Set();
      allVariants.forEach(function (variant) {
        if (!variant || !variant.availableForSale || !isVariantVisibleByActiveMetafield(variant)) {
          return;
        }

        const variantId = parseVariantIdFromGid(variant.id);
        if (variantId) {
          availableVisibleVariantIds.add(String(variantId));
        }

        const colorOpt = (variant.selectedOptions || []).find(function (option) {
          return option && option.name && option.value && option.name.toLowerCase().indexOf('color') !== -1;
        });
        if (colorOpt && colorOpt.value) {
          availableVisibleColors.add(colorOpt.value.trim().toLowerCase());
        }
      });

      const existingSlides = track.querySelectorAll('.product-card-color-slide');
      existingSlides.forEach(function (slide) {
        const button = slide.querySelector('.product-card-color-option');
        if (!button) {
          return;
        }

        const colorKey = (button.getAttribute('data-color') || '').trim().toLowerCase();
        const variantId = (button.getAttribute('data-variant-id') || '').trim();
        const isAvailableByColor = !!colorKey && availableVisibleColors.has(colorKey);
        const isAvailableByVariant = !!variantId && availableVisibleVariantIds.has(variantId);

        if (!isAvailableByColor && !isAvailableByVariant) {
          slide.remove();
        }
      });

      const remainingButtons = track.querySelectorAll('.product-card-color-option');
      if (remainingButtons.length) {
        const hasActive = Array.from(remainingButtons).some(function (button) {
          return button.classList.contains('active');
        });
        if (!hasActive) {
          remainingButtons[0].classList.add('active');
        }
      }

      const existingButtons = track.querySelectorAll('.product-card-color-option');
      const existingColorKeys = new Set();
      existingButtons.forEach(function (button) {
        const color = button.getAttribute('data-color');
        if (!color) {
          return;
        }
        existingColorKeys.add(color.trim().toLowerCase());
      });

      const colorMap = new Map();
      allVariants.forEach(function (variant) {
        const colorOpt = (variant.selectedOptions || []).find(function (option) {
          return option && option.name && option.value && option.name.toLowerCase().indexOf('color') !== -1;
        });

        if (!colorOpt || !colorOpt.value) {
          return;
        }

        const colorValue = colorOpt.value.trim();
        const colorKey = colorValue.toLowerCase();
        if (!colorMap.has(colorKey)) {
          colorMap.set(colorKey, {
            colorValue: colorValue,
            preferredVariant: null,
            preferredImage: '',
            fallbackImages: [],
            customFallbackImages: [],
            matchesFilteredColor: false,
            preferredVariantMatchesFilteredColor: false,
            preferredImageMatchesFilteredColor: false,
            preferredVariantFilteredColorPriority: -1,
            preferredImageFilteredColorPriority: -1
          });
        }

        const entry = colorMap.get(colorKey);
        const isVisibleVariant = isVariantVisibleByActiveMetafield(variant);
        const isSelectableVariant = isVisibleVariant && variant.availableForSale;
        const variantImage = pickExactVariantImage(variant, colorValue);
        const variantFilteredColorPriority = getVariantFilteredColorPriority(variant, filteredColorKeys, colorValue);
        const matchesFilteredColor = variantFilteredColorPriority !== -1;

        getVariantImageCandidates(variant).forEach(function (candidateUrl) {
          if (entry.fallbackImages.indexOf(candidateUrl) === -1) {
            entry.fallbackImages.push(candidateUrl);
          }
        });

        getCustomImageCandidates(variant).forEach(function (candidateUrl) {
          if (entry.customFallbackImages.indexOf(candidateUrl) === -1) {
            entry.customFallbackImages.push(candidateUrl);
          }
        });

        if (matchesFilteredColor) {
          entry.matchesFilteredColor = true;
        }

        if (isSelectableVariant) {
          const shouldReplacePreferredVariant = !entry.preferredVariant ||
            (!entry.preferredVariantMatchesFilteredColor && matchesFilteredColor) ||
            (entry.preferredVariantMatchesFilteredColor && matchesFilteredColor && variantFilteredColorPriority > entry.preferredVariantFilteredColorPriority);

          if (shouldReplacePreferredVariant) {
            entry.preferredVariant = variant;
            entry.preferredVariantMatchesFilteredColor = matchesFilteredColor;
            entry.preferredVariantFilteredColorPriority = matchesFilteredColor ? variantFilteredColorPriority : -1;
          }
        }

        if (variantImage) {
          const shouldReplaceImageForFilteredColor = matchesFilteredColor &&
            (!entry.preferredImageMatchesFilteredColor || variantFilteredColorPriority > entry.preferredImageFilteredColorPriority);
          if (!entry.preferredImage || shouldReplaceImageForFilteredColor) {
            entry.preferredImage = variantImage;
            entry.preferredImageMatchesFilteredColor = matchesFilteredColor;
            entry.preferredImageFilteredColorPriority = matchesFilteredColor ? variantFilteredColorPriority : -1;
          }
        }
      });

      if (!colorMap.size) {
        return;
      }

      colorMap.forEach(function (entry) {
        if (entry.customFallbackImages.length > 0) {
          entry.preferredImage = entry.customFallbackImages[0];
        } else if (!entry.preferredImage) {
          if (entry.fallbackImages.length >= 1) {
            entry.preferredImage = entry.fallbackImages[0];
          }
        }
      });

      function getPreferredHoverImage(entry) {
        if (!entry || !entry.preferredImage) {
          return '';
        }

        const mainImageUrl = normalizeImageUrl(entry.preferredImage);
        const hoverCandidates = entry.customFallbackImages.length > 1
          ? entry.customFallbackImages
          : entry.fallbackImages;

        for (let index = 0; index < hoverCandidates.length; index += 1) {
          const candidateUrl = hoverCandidates[index];
          if (normalizeImageUrl(candidateUrl) !== mainImageUrl) {
            return candidateUrl;
          }
        }

        return '';
      }

      const baseHref = productEl.querySelector('.product-card-link')?.getAttribute('href') || '';
      const hasImageSlider = isProductCardSlider(productEl);
      existingButtons.forEach(function (button) {
        const colorKey = (button.getAttribute('data-color') || '').trim().toLowerCase();
        const entry = colorMap.get(colorKey);
        if (!entry || !entry.preferredVariant) {
          return;
        }

        const variant = entry.preferredVariant;
        const variantId = parseVariantIdFromGid(variant.id);
        if (!variantId) {
          return;
        }

        button.setAttribute('data-variant-id', variantId);
        button.setAttribute('data-price', String(moneyAmountToCents(variant.price && variant.price.amount)));
        button.setAttribute('data-compare-at-price', String(moneyAmountToCents(variant.compareAtPrice && variant.compareAtPrice.amount)));

        if (entry.preferredImage) {
          button.setAttribute('data-image', getSizedImageUrl(entry.preferredImage));
        }

        const hoverImage = getPreferredHoverImage(entry);
        if (hoverImage) {
          button.setAttribute('data-hover-image', getSizedImageUrl(hoverImage));
        } else {
          button.removeAttribute('data-hover-image');
        }

        if (hasImageSlider) {
          button.setAttribute('data-images', JSON.stringify(getColorImages(entry, productData)));
        }

        button.setAttribute('data-variant-url', buildVariantUrl(baseHref, variantId));
      });

      const saleColorKeys = (productEl.dataset.saleColors || '').toLowerCase().split('|').filter(Boolean);
      const isSaleColor = function (colorKey) { return saleColorKeys.indexOf(colorKey) !== -1; };
      const orderedColorKeys = Array.from(colorMap.keys()).sort(function (a, b) {
        return Number(isSaleColor(b)) - Number(isSaleColor(a));
      });

      orderedColorKeys.forEach(function (colorKey) {
        const entry = colorMap.get(colorKey);
        if (existingColorKeys.has(colorKey)) {
          return;
        }

        const variant = entry.preferredVariant;
        if (!variant) {
          return;
        }

        const variantId = parseVariantIdFromGid(variant.id);
        if (!variantId) {
          return;
        }

        const slide = document.createElement('div');
        slide.className = 'product-card-color-slide swiper-slide';
        slide.setAttribute('role', 'listitem');

        const button = document.createElement('div');
        button.setAttribute('role', 'button');
        button.className = 'option-color product-card-color-option';
        button.setAttribute('aria-label', entry.colorValue + ' color');
        button.setAttribute('data-color', entry.colorValue);
        button.setAttribute('data-variant-id', variantId);
        button.setAttribute('data-price', String(moneyAmountToCents(variant.price && variant.price.amount)));
        button.setAttribute('data-compare-at-price', String(moneyAmountToCents(variant.compareAtPrice && variant.compareAtPrice.amount)));

        const variantImage = entry.preferredImage || '';
        if (variantImage) {
          button.setAttribute('data-image', getSizedImageUrl(variantImage));
        }

        const hoverImage = getPreferredHoverImage(entry);
        if (hoverImage) {
          button.setAttribute('data-hover-image', getSizedImageUrl(hoverImage));
        }

        if (hasImageSlider) {
          button.setAttribute('data-images', JSON.stringify(getColorImages(entry, productData)));
        }

        button.setAttribute('data-variant-url', buildVariantUrl(baseHref, variantId));
        button.style.backgroundImage = 'url(https://imagens.liveoficial.com.br/color-sku/' + entry.colorValue.toUpperCase() + '.png)';

        const hiddenText = document.createElement('span');
        hiddenText.className = 'hide-text';
        hiddenText.textContent = entry.colorValue;
        button.appendChild(hiddenText);

        slide.appendChild(button);
        track.appendChild(slide);
      });

      // The "More" button (single-row mode) must stay last so it sits right after
      // the last visible swatch — appendChild moves an existing node, it doesn't clone it.
      const moreButton = track.querySelector('.product-card-colors-more');
      if (moreButton) {
        track.appendChild(moreButton);
      }

      if (slider.__productCardColorsSwiper) {
        slider.__productCardColorsSwiper.update();
      } else {
        // Slides can be rendered after the first init pass, so retry init for this slider scope.
        slider.dataset.swiperReady = 'false';
        initProductCardColorSwipers(slider.closest('.product-card-colors-wrapper') || slider.parentElement || document);
      }

      if (filteredColorKeys.length) {
        const allButtons = track.querySelectorAll('.product-card-color-option');
        let matchedButton = null;
        let bestMatchPriority = -1;
        allButtons.forEach(function (btn) {
          const btnColorKey = normalizeColorToken(btn.getAttribute('data-color') || '');
          const entry = colorMap.get((btn.getAttribute('data-color') || '').trim().toLowerCase());
          const liveColorKey = entry && entry.preferredVariant && entry.preferredVariant.liveColor
            ? normalizeColorToken(entry.preferredVariant.liveColor.value || '')
            : '';

          const matchPriority = getButtonFilteredColorPriority(btnColorKey, liveColorKey, filteredColorPriorityMap);
          if (matchPriority > bestMatchPriority) {
            bestMatchPriority = matchPriority;
            matchedButton = btn;
          }
        });
        if (matchedButton) {
          allButtons.forEach(function (btn) { btn.classList.remove('active'); });
          matchedButton.classList.add('active');
        }
      } else if (colorSearchKey) {
        const allButtons = track.querySelectorAll('.product-card-color-option');
        let matchedButton = null;
        allButtons.forEach(function (btn) {
          if (matchedButton) return;
          const btnColorKey = normalizeColorToken(btn.getAttribute('data-color') || '');
          if (btnColorKey && (btnColorKey.indexOf(colorSearchKey) !== -1 || colorSearchKey.indexOf(btnColorKey) !== -1)) {
            matchedButton = btn;
          }
        });
        if (matchedButton) {
          allButtons.forEach(function (btn) { btn.classList.remove('active'); });
          matchedButton.classList.add('active');
        }
      } else if (mainColorKey) {
        const allButtons = track.querySelectorAll('.product-card-color-option');
        let matchedButton = null;
        allButtons.forEach(function (btn) {
          const btnColorKey = normalizeColorToken(btn.getAttribute('data-color') || '');
          if (btnColorKey === mainColorKey && !matchedButton) {
            matchedButton = btn;
          }
        });
        if (matchedButton) {
          allButtons.forEach(function (btn) { btn.classList.remove('active'); });
          matchedButton.classList.add('active');
        }
      }

      const allFinalButtons = track.querySelectorAll('.product-card-color-option');
      if (allFinalButtons.length) {
        const hasActive = Array.from(allFinalButtons).some(function (btn) { return btn.classList.contains('active'); });
        if (!hasActive) {
          allFinalButtons[0].classList.add('active');
        }
      }
    }

    function syncActiveSwatchToDom(productEl) {
      const activeBtn = productEl.querySelector('.product-card-color-option.active');
      if (!activeBtn) return;

      const variantId = activeBtn.getAttribute('data-variant-id');
      if (variantId) {
        productEl.setAttribute('data-current-variant-id', variantId);
        productEl.querySelectorAll('.item-quick-add, .item-quick-add__button').forEach(function (scope) {
          scope.setAttribute('data-current-variant-id', variantId);
        });
      }

      const variantUrl = activeBtn.getAttribute('data-variant-url');
      if (variantUrl) {
        productEl.querySelectorAll('.product-card-link').forEach(function (link) {
          link.setAttribute('href', variantUrl);
        });
      }
    }

    async function renderColors(allVariants, productEl, productData) {
      renderMissingCardColors(allVariants, productEl, productData);
      syncActiveSwatchToDom(productEl);

      const container = productEl.querySelector('#item-product-img');
      const hasImageSlider = isProductCardSlider(productEl);
      const containerHover = hasImageSlider ? null : ensureProductCardImageContainer(
        productEl,
        'item-product-img-hover',
        'hover-img item-product-img'
      );

      if (!container) return;

      // Reveal the SSR skeleton on every exit path; a timeout guards paths that never swap.
      let resolvingSafety = null;
      const clearResolving = function () {
        if (resolvingSafety) { clearTimeout(resolvingSafety); resolvingSafety = null; }
        container.classList.remove('is-resolving');
      };
      if (container.classList.contains('is-resolving')) {
        resolvingSafety = setTimeout(clearResolving, 3000);
      }

      // On a color-search results page the server already rendered the correct
      // color image (color_search_image) by matching the searched SKU code, which
      // is more reliable than the API color-option matching below. Keep that main
      // image (no flicker, no wrong-color overwrite) and just fill the hover slot,
      // which SSR leaves as a placeholder. Cards without an SSR image (placeholders)
      // fall through to the API pass so they still get an image.
      // Skip this when an explicit Color filter is applied — then the filter must
      // win, so we let the normal filtered-color logic below run (images + swatches).
      if (getColorSearchKey(productEl) && productEl.dataset.colorSearchImage && !shouldMatchFilteredColorImages(productEl)) {
        if (hasImageSlider) {
          setProductCardSliderImages(productEl, getColorSearchImages(allVariants, productEl, container));
        } else {
          fillColorSearchHover(allVariants, productEl, container, containerHover);
        }
        clearResolving();
        return;
      }

      const filteredColorKeys = getFilteredColorKeys(productEl);
      const shouldMatchFiltered = shouldMatchFilteredColorImages(productEl);
      const mainColorKey = !filteredColorKeys.length ? normalizeColorToken(productEl.dataset.mainColor || '') : '';
      const requestedColorKey = getRequestedColorKey(productEl, allVariants);

      const searchHintKey = !filteredColorKeys.length
        ? normalizeColorToken(productEl.dataset.colorSearchSku || '')
        : '';

      const colorsMap = {};
      let sequence = 0;

      allVariants.forEach(variant => {
        const colorOpt = (variant.selectedOptions || []).find(function (option) {
          return option && option.name && option.value && option.name.toLowerCase().indexOf('color') !== -1;
        });
        if (!colorOpt) return;
        const color = colorOpt.value;
        const customUrls = getCustomImageCandidates(variant);
        const exactUrls = getVariantImageCandidates(variant)
          .sort(function (leftUrl, rightUrl) {
            const colorToken = normalizeColorToken(color);
            const leftMatches = colorToken && normalizeColorToken(leftUrl).indexOf(colorToken) !== -1;
            const rightMatches = colorToken && normalizeColorToken(rightUrl).indexOf(colorToken) !== -1;
            if (leftMatches !== rightMatches) return leftMatches ? -1 : 1;
            const leftIsCustom = customUrls.indexOf(leftUrl) !== -1;
            const rightIsCustom = customUrls.indexOf(rightUrl) !== -1;
            if (leftIsCustom !== rightIsCustom) return leftIsCustom ? -1 : 1;
            return 0;
          });
        if (!colorsMap[color]) {
          colorsMap[color] = {
            colorValue: color,
            available: false,
            visible: false,
            sequence: sequence++,
            images: [],
            fallbackImages: [],
            customFallbackImages: [],
            matchesFilteredColor: false,
            filteredColorPriority: -1,
            matchesMainColor: !!(mainColorKey && normalizeColorToken(color) === mainColorKey),
            matchesSearchHint: false,
            matchesRequestedColor: !!(requestedColorKey && normalizeColorToken(color) === requestedColorKey),
            preferredVariantId: ''
          };
        }

        const variantFilteredColorPriority = getVariantFilteredColorPriority(variant, filteredColorKeys, color);
        const matchesFilteredColor = variantFilteredColorPriority !== -1;
        getVariantImageCandidates(variant).forEach(function (candidateUrl) {
          if (colorsMap[color].fallbackImages.indexOf(candidateUrl) === -1) {
            colorsMap[color].fallbackImages.push(candidateUrl);
          }
        });
        getCustomImageCandidates(variant).forEach(function (candidateUrl) {
          if (colorsMap[color].customFallbackImages.indexOf(candidateUrl) === -1) {
            colorsMap[color].customFallbackImages.push(candidateUrl);
          }
        });

        if (variant.availableForSale) {
          colorsMap[color].available = true;
        }
        if (isVariantVisibleByActiveMetafield(variant)) {
          colorsMap[color].visible = true;
        }
        if (variant.availableForSale && isVariantVisibleByActiveMetafield(variant) && !colorsMap[color].preferredVariantId) {
          colorsMap[color].preferredVariantId = parseVariantIdFromGid(variant.id);
        }
        if (exactUrls.length) {
          const previousFilteredColorPriority = colorsMap[color].filteredColorPriority;
          const hadFilteredColorMatch = colorsMap[color].matchesFilteredColor;
          const existingToken = normalizeColorToken((colorsMap[color].images && colorsMap[color].images[0]) || '');
          const nextToken = normalizeColorToken(exactUrls[0]);
          const colorToken = normalizeColorToken(color);
          const existingMatches = !!(colorsMap[color].images.length && colorToken && existingToken.indexOf(colorToken) !== -1);
          const nextMatches = !!(colorToken && nextToken.indexOf(colorToken) !== -1);
          const shouldPreferFilteredColor = matchesFilteredColor &&
            (!hadFilteredColorMatch || variantFilteredColorPriority > previousFilteredColorPriority);

          if (!colorsMap[color].images.length || shouldPreferFilteredColor || (!existingMatches && nextMatches)) {
            colorsMap[color].images = exactUrls.map(getSizedImageUrl);
          }
        }

        if (matchesFilteredColor) {
          colorsMap[color].matchesFilteredColor = true;
          if (variantFilteredColorPriority > colorsMap[color].filteredColorPriority) {
            colorsMap[color].filteredColorPriority = variantFilteredColorPriority;
          }
        }

        if (searchHintKey && !colorsMap[color].matchesSearchHint) {
          const liveColorKey = normalizeColorToken(variant.liveColor ? (variant.liveColor.value || '') : '');
          const colorOptionKey = normalizeColorToken(color);
          if (
            (liveColorKey && liveColorKey.indexOf(searchHintKey) !== -1) ||
            (colorOptionKey && colorOptionKey.indexOf(searchHintKey) !== -1)
          ) {
            colorsMap[color].matchesSearchHint = true;
          }
        }
      });

      Object.keys(colorsMap).forEach(function (colorKey) {
        const meta = colorsMap[colorKey];
        // lead image for getColorImages, the same one the card shows as its main image
        meta.preferredImage = meta.fallbackImages[0] || '';
        if (meta.customFallbackImages.length > 0) {
          meta.images = meta.customFallbackImages.map(getSizedImageUrl);
        } else {
          meta.images = meta.fallbackImages.length > 0 ? [getSizedImageUrl(meta.fallbackImages[0])] : [];
        }
      });

      // Hide the card if a color filter is active and no available+visible variant matches it
      if (shouldMatchFiltered && filteredColorKeys.length) {
        const hasMatchingAvailableColor = Object.values(colorsMap).some(function (meta) {
          return meta.matchesFilteredColor && meta.available && meta.visible;
        });
        if (!hasMatchingAvailableColor) {
          productEl.style.display = 'none';
          return;
        }
        productEl.style.display = '';
      }

      const sortedColorMetas = Object.values(colorsMap)
        .sort((a, b) => {
          if (filteredColorKeys.length && a.filteredColorPriority !== b.filteredColorPriority) {
            return b.filteredColorPriority - a.filteredColorPriority;
          }

          if (searchHintKey && a.matchesSearchHint !== b.matchesSearchHint) {
            return a.matchesSearchHint ? -1 : 1;
          }

          if (requestedColorKey && a.matchesRequestedColor !== b.matchesRequestedColor) {
            return a.matchesRequestedColor ? -1 : 1;
          }

          if (mainColorKey && a.matchesMainColor !== b.matchesMainColor) {
            return a.matchesMainColor ? -1 : 1;
          }

          return a.sequence - b.sequence;
        })
        .filter((meta) => meta.visible && (meta.available || meta.matchesRequestedColor));

      const orderedImages = sortedColorMetas
        .flatMap((meta) => meta.images)
        .filter(Boolean);

      if (!orderedImages.length) {
        // No color-matched images from the API — keep whatever the SSR rendered
        // (the variant image or the animated skeleton placeholder). Emptying here
        // is what produced blank frames with no preview on color-search cards.
        clearResolving();
        return;
      }

      // If the Storefront API returned no custom metafield images, the Liquid SSR
      // already rendered the correct images. Overwriting would break the hover.
      const hasApiCustomImages = sortedColorMetas.some(function(m) {
        return m.customFallbackImages && m.customFallbackImages.length > 0;
      });
      if (!hasApiCustomImages) {
        clearResolving();
        return;
      }

      // Server-side Liquid already rendered the correct color image for this search.
      // Activate the matching swatch but leave the main image untouched.
      if (searchHintKey && productEl.hasAttribute('data-color-search-image') && !filteredColorKeys.length) {
        const matchedColor = searchHintKey
          ? Object.keys(colorsMap).find(function (c) { return colorsMap[c].matchesSearchHint; })
          : null;
        if (matchedColor) {
          const allBtns = productEl.querySelectorAll('.product-card-color-option');
          let matchedBtn = null;
          allBtns.forEach(function (btn) {
            if (matchedBtn) return;
            if ((btn.getAttribute('data-color') || '').trim() === matchedColor) matchedBtn = btn;
          });
          if (matchedBtn) {
            allBtns.forEach(function (btn) { btn.classList.remove('active'); });
            matchedBtn.classList.add('active');
            syncActiveSwatchToDom(productEl);
          }
        }
        if (hasImageSlider) {
          setProductCardSliderImages(productEl, getColorSearchImages(allVariants, productEl, container));
        }
        return;
      }

      if (sortedColorMetas.length && !productEl.querySelector('.product-card-color-option.active')) {
        const activeVariantId = sortedColorMetas[0].preferredVariantId;
        if (activeVariantId) {
          productEl.setAttribute('data-current-variant-id', activeVariantId);
          productEl.querySelectorAll('.item-quick-add, .item-quick-add__button').forEach(function (scope) {
            scope.setAttribute('data-current-variant-id', activeVariantId);
          });
          const baseLink = productEl.querySelector('.product-card-link');
          const baseHref = baseLink ? (baseLink.getAttribute('href') || '') : '';
          const variantUrl = buildVariantUrl(baseHref, activeVariantId);
          productEl.querySelectorAll('.product-card-link').forEach(function (link) {
            link.setAttribute('href', variantUrl);
          });
        }
      }

      const firstColorImages = sortedColorMetas.length > 0 ? sortedColorMetas[0].images : [];
      const mainImageUrl = firstColorImages[0] || orderedImages[0] || '';
      const hoverImageUrl = firstColorImages.length > 1 ? firstColorImages[1] : '';
      const itemImageWrapper = productEl.querySelector('.item-img');
      const hasHoverImage = !!hoverImageUrl && normalizeImageUrl(hoverImageUrl) !== normalizeImageUrl(mainImageUrl);

      if (hasImageSlider) {
        const sliderImages = sortedColorMetas.length ? getColorImages(sortedColorMetas[0], productData) : [];
        setProductCardSliderImages(productEl, sliderImages.length ? sliderImages : [mainImageUrl]);
        // same file already on slide 0 (SSR and API URLs differ only in host/params)
        const currentSlideImage = container.querySelector('img');
        const currentSlideSrc = currentSlideImage ? (currentSlideImage.getAttribute('src') || currentSlideImage.getAttribute('data-src') || '') : '';
        if (currentSlideSrc && imageFilename(currentSlideSrc) === imageFilename(mainImageUrl)) {
          clearResolving();
          return;
        }
      } else if (itemImageWrapper) {
        itemImageWrapper.classList.toggle('has-hover', hasHoverImage);
      }

      const currentMainImage = container.querySelector('img');
      const currentHoverImage = containerHover ? containerHover.querySelector('img') : null;
      const currentMainSrc = normalizeImageUrl(currentMainImage?.getAttribute('src'));
      const currentHoverSrc = normalizeImageUrl(currentHoverImage?.getAttribute('src'));
      const targetMainSrc = normalizeImageUrl(mainImageUrl);
      const targetHoverSrc = normalizeImageUrl(hoverImageUrl);

      if (currentMainSrc === targetMainSrc && currentHoverSrc === targetHoverSrc) {
        clearResolving();
        return;
      }

      const swapImages = function () {
        container.innerHTML = '';
        if (containerHover) {
          containerHover.innerHTML = '';
        }

        const mainImage = document.createElement('img');
        mainImage.src = mainImageUrl;
        mainImage.alt = Utilities.cardImageAlt(container);
        mainImage.width = IMAGE_WIDTH;
        mainImage.height = IMAGE_WIDTH;
        mainImage.loading = 'lazy';
        mainImage.decoding = 'async';
        mainImage.className = 'pcg-fade-in';
        container.appendChild(mainImage);

        if (containerHover && hoverImageUrl) {
          const hoverImage = document.createElement('img');
          hoverImage.src = hoverImageUrl;
          hoverImage.alt = Utilities.cardImageAlt(container);
          hoverImage.width = IMAGE_WIDTH;
          hoverImage.height = IMAGE_WIDTH;
          hoverImage.loading = 'lazy';
          hoverImage.decoding = 'async';
          hoverImage.fetchPriority = 'low';
          containerHover.appendChild(hoverImage);
        }

        clearResolving(); // drop the skeleton; resolved image fades in
      };

      // Preload, then swap + fade in so the correction is a crossfade, not a pop.
      if (mainImageUrl) {
        const preload = new Image();
        preload.onload = swapImages;
        preload.onerror = swapImages;
        preload.src = mainImageUrl;
      } else {
        swapImages();
      }
    }

    const gridRoot = document.getElementById('CollectionProductGrid') || document.body;
    if (gridRoot) {
      const observer = new MutationObserver((mutations) => {
        const hasRelevantChanges = mutations.some((mutation) => {
          if (mutation.type !== 'childList' || !mutation.addedNodes.length) {
            return false;
          }

          return Array.from(mutation.addedNodes).some(isRelevantGridMutationNode);
        });

        if (hasRelevantChanges) {
          scheduleProcessItems(gridRoot);
        }
      });

      observer.observe(gridRoot, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('click', function (event) {
      const sizeButton = event.target.closest('.product-card-size-option');
      if (!sizeButton || sizeButton.disabled) {
        return;
      }

      // .product-card-sizes now renders inside the card's <a> image link (for absolute
      // positioning against the image) — without this the click would bubble up and
      // navigate to the PDP instead of adding to cart / opening the quickshop popup.
      event.preventDefault();

      const sizesContainer = sizeButton.closest('.product-card-sizes');
      const card = sizeButton.closest('.item-product');
      if (!sizesContainer || !card) {
        return;
      }

      const rawId = card.getAttribute('id') || '';
      const numericId = rawId.replace(/\D+/g, '');
      if (!numericId) {
        return;
      }

      const cached = variantsCache.get(`gid://shopify/Product/${numericId}`);
      if (!cached || !cached.variants || !cached.variants.length) {
        return;
      }

      const size = sizeButton.getAttribute('data-size') || '';
      const currentVariantId = card.getAttribute('data-current-variant-id') || sizesContainer.getAttribute('data-current-variant-id') || '';
      const strictVariant = resolveVariantForSize(cached.variants, size, currentVariantId, true);
      const targetVariant = strictVariant || resolveVariantForSize(cached.variants, size, currentVariantId, false);
      if (!targetVariant) {
        return;
      }

      const targetVariantId = parseVariantIdFromGid(targetVariant.id);
      if (!targetVariantId) {
        return;
      }

      // Only add straight to cart when the match is exact (same color as currently shown) —
      // otherwise fall through to the quickshop popup so the shopper consciously picks the
      // substitute color instead of it being silently added on their behalf.
      const shouldAddToCart = sizesContainer.getAttribute('data-add-to-cart') === 'true' && !!strictVariant;

      if (shouldAddToCart) {
        if (typeof Utilities === 'undefined' || typeof Utilities.addProductToCart !== 'function') {
          return;
        }

        // Block every size on this card while the request is in flight — otherwise a shopper
        // can fire off several add-to-cart calls before the first one resolves.
        const siblingButtons = sizesContainer.querySelectorAll('.product-card-size-option:not(.sold-out)');
        siblingButtons.forEach(function (btn) {
          btn.disabled = true;
        });
        sizeButton.classList.add('loading');

        const restoreSizeButtons = function () {
          sizeButton.classList.remove('loading');
          siblingButtons.forEach(function (btn) {
            btn.disabled = false;
          });
        };

        // Send properties[_compare-price] (in cents) when the variant is on sale,
        // exactly like the PDP form and the quick-add popup do. Without it, an
        // on-sale variant added from a card size-swatch would land as a SEPARATE
        // line item from the same variant added on the PDP/popup (mismatched
        // line-item properties). Omit it when there's no compare-at price so those
        // variants still merge (all paths then send no property).
        var lvAddData = { id: parseInt(targetVariantId, 10), quantity: 1 };
        var lvCompareCents = (targetVariant.compareAtPrice && targetVariant.compareAtPrice.amount != null)
          ? Math.round(parseFloat(targetVariant.compareAtPrice.amount) * 100)
          : 0;
        if (lvCompareCents > 0) {
          lvAddData.properties = { '_compare-price': String(lvCompareCents) };
        }

        Utilities.addProductToCart(
          lvAddData,
          restoreSizeButtons,
          function (message) {
            restoreSizeButtons();
            if (message) {
              alert(message);
            }
          },
          'grid'
        );
        return;
      }

      if (typeof quickAddPopupInit !== 'function') {
        return;
      }
      sizeButton.setAttribute('data-product-id', numericId);
      sizeButton.setAttribute('data-current-variant-id', targetVariantId);
      quickAddPopupInit(sizeButton);
    });

    document.addEventListener('shopify:section:load', function () {
      scheduleProcessItems();
      scheduleWishlistReload();
    });

    window.addEventListener('popstate', function () {
      scheduleProcessItems();
      scheduleWishlistReload();
    });

    scheduleProcessItems();
    scheduleWishlistReload();
  }

  // the map is ~30KB of JSON, so parse it once, not once per swatch
  let cardColorMap;
  function cardSwatchColorName(code) {
    if (!code) return '';
    if (cardColorMap === undefined) {
      try {
        const el = document.querySelector('[data-colors-list]');
        cardColorMap = el ? JSON.parse(el.textContent) : null;
      } catch (error) {
        cardColorMap = null;
      }
    }
    const name = cardColorMap ? cardColorMap[String(code).toUpperCase()] : '';
    return (name && String(name).trim()) || String(code);
  }

  // One tab stop per swatch row, arrows move inside it: 200+ swatches on a grid would
  // otherwise bury the rest of the page. Re-applied by observer because the rows are
  // rebuilt from the Storefront API.
  function syncCardSwatchKeyboard() {
    document.querySelectorAll('.product-card-colors-wrapper').forEach(function (wrapper) {
      const track = wrapper.querySelector('.product-card-colors-track') || wrapper.querySelector('.product-card-colors');
      if (!track) return;

      const swatches = Array.from(track.querySelectorAll('.product-card-color-option'))
        .filter(function (swatch) { return swatch.getClientRects().length > 0; });
      if (!swatches.length) return;

      if (track.getAttribute('role') !== 'group') track.setAttribute('role', 'group');
      if (!track.hasAttribute('aria-label')) track.setAttribute('aria-label', 'Color');

      let activeIndex = swatches.findIndex(function (swatch) { return swatch.classList.contains('active'); });
      if (activeIndex < 0) activeIndex = 0;

      swatches.forEach(function (swatch, i) {
        const name = cardSwatchColorName(swatch.getAttribute('data-color'));
        if (name && swatch.getAttribute('aria-label') !== name) swatch.setAttribute('aria-label', name);
        const pressed = i === activeIndex ? 'true' : 'false';
        if (swatch.getAttribute('aria-pressed') !== pressed) swatch.setAttribute('aria-pressed', pressed);
        const tabindex = i === activeIndex ? '0' : '-1';
        if (swatch.getAttribute('tabindex') !== tabindex) swatch.setAttribute('tabindex', tabindex);
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    const swatch = e.target.closest && e.target.closest('.product-card-color-option');
    if (!swatch) return;

    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      swatch.click();
      return;
    }

    const wrapper = swatch.closest('.product-card-colors-wrapper');
    if (!wrapper) return;

    const visibleSwatches = function () {
      return Array.from(wrapper.querySelectorAll('.product-card-color-option')).filter(
        function (s) { return s.getClientRects().length > 0; }
      );
    };

    let list = visibleSwatches();
    const current = list.indexOf(swatch);
    if (current === -1) return;

    const movingForward = e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'End';
    const atEnd = current === list.length - 1;
    // the "+N" button hides the rest of the row; arrowing past the last one opens them
    if (movingForward && (atEnd || e.key === 'End')) {
      const more = wrapper.querySelector('.product-card-colors-more');
      if (more) {
        more.click();
        list = visibleSwatches();
      }
    }

    let next = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (list.indexOf(swatch) + 1) % list.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (list.indexOf(swatch) - 1 + list.length) % list.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = list.length - 1;
    else return;

    e.preventDefault();
    const target = list[next];
    if (!target) return;
    list.forEach(function (s) {
      if (s !== target && s.getAttribute('tabindex') !== '-1') s.setAttribute('tabindex', '-1');
    });
    target.setAttribute('tabindex', '0');
    target.focus();

    const slider = target.closest('.product-card-colors');
    const slide = target.closest('.product-card-color-slide');
    if (slider && slider.swiper && slide) {
      const slides = Array.from(slider.querySelectorAll('.product-card-color-slide'));
      slider.swiper.slideTo(slides.indexOf(slide));
    }

    target.click();
  });

  document.addEventListener('click', function (e) {
    const more = e.target.closest && e.target.closest('.product-card-colors-more');
    if (!more) return;
    more.setAttribute('aria-expanded', 'true');
  });

  let swatchSyncPending = false;
  function scheduleSwatchSync() {
    if (swatchSyncPending) return;
    swatchSyncPending = true;
    requestAnimationFrame(function () {
      swatchSyncPending = false;
      syncCardSwatchKeyboard();
    });
  }

  function watchSwatchRows() {
    syncCardSwatchKeyboard();
    const roots = document.querySelectorAll('.collection-wrapper, .product-grid, .collection-container');
    const targets = roots.length ? roots : [document.body];
    targets.forEach(function (root) {
      new MutationObserver(scheduleSwatchSync).observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductGridFallback();
      watchSwatchRows();
    });
  } else {
    initProductGridFallback();
    watchSwatchRows();
  }
}
